import { InjectionToken } from "@angular/core";
import { PortalProductStrategy } from "../services";

export const PORTAL_PRODUCT_SERVICE_TOKEN = new InjectionToken<PortalProductStrategy>("PORTAL_PRODUCT_SERVICE_TOKEN");
